<template>
  <v-card>
    <v-toolbar card color="primary" dark>
      <v-toolbar-title class="body-2">INFORMACION</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close-information')" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-container fluid grid-list-xl>
        <v-layout row wrap>
          <v-flex
            text-sm-left
            lg12
            sm12
            v-if="isImagePath(item)"
            align="center"
            justify="center"
          >
            <v-img
              :src="getPath(item)"
              aspect-ratio="1"
              max-height="300"
              contain
            ></v-img>
          </v-flex>
          <v-flex text-sm-right lg12 sm12 v-else>
            <v-btn color="success" link target="_blank" :href="getPath(item)">
              Abrir Archivo<v-icon right>cloud_download</v-icon>
            </v-btn>
          </v-flex>
          <v-flex text-sm-left lg12 sm12>{{ item.observationsDenied }}</v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { getFullPath } from '@/helpers/TransitHelper'
import isImageUrl from 'is-image-url'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getPath(item) {
      let path = ''
      if (item.type == 'rejected') {
        path = item.photoDenied
      } else if (item.type == 'payment') {
        path = item.photoPayed
      }
      if (path) return getFullPath(path)
      else return null
    },
    isImagePath(item) {
      const path = this.getPath(item)
      return isImageUrl(path)
    },
  },
}
</script>
<style scope="css">
.v-image-attachment {
  width: 100%;
  max-width: 100%;
  border: 5px solid #81b5de;
}
</style>
